import axios from 'axios';
import path from '../config/imageUpload';
const Compress = require('compress.js').default;
const compress = new Compress();

var ImageUploadManager = {};

ImageUploadManager.uploadBanner = async image => {
  try {
    const results = await compress.compress([image], {
      size: 1, // the max size in MB, defaults to 2MB
      quality: 0.9, // the quality of the image, max is 1,
    });

    const img1 = results[0];
    const base64str = img1.data;
    const imgExt = img1.ext;
    const compressedImage = Compress.convertBase64ToFile(base64str, imgExt);

    const formData = new FormData();
    formData.append('image', compressedImage);
    return (
      await axios.post(path + 'banner', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    ).data;
  } catch (err) {
    console.log(err);
  }
};

ImageUploadManager.uploadAvatar = async image => {
  try {
    const results = await compress.compress([image], {
      size: 1, // the max size in MB, defaults to 2MB
      quality: 1, // the quality of the image, max is 1,
      maxWidth: 512, // the max width of the output image, defaults to 1920px
      maxHeight: 512, // the max height of the output image, defaults to 1920px
      resize: true, // defaults to true, set false if you do not want to resize the image width and height
    });

    const img1 = results[0];
    const base64str = img1.data;
    const imgExt = img1.ext;
    const compressedImage = Compress.convertBase64ToFile(base64str, imgExt);

    const formData = new FormData();
    formData.append('image', compressedImage);
    return (
      await axios.post(path + 'avatar', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    ).data;
  } catch (err) {
    console.log(err);
  }
};

export default ImageUploadManager;
